<template>
	<div :class="classNames">
		<div :class="classNames+'_con'">
			<div :class="classNames+'_con_table'">
				<el-table :data="tableObj.list"
					:header-cell-style="{background: '#F5F7FA',color:'#454D53'}">
                    <div slot="empty">
						<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
					</div>
					<el-table-column :label="item.label" :prop="item.prop" v-for="(item, index) in headerList"
						:type="item.prop" :key="index" :width="item.width">
						<template slot-scope="scope">
                            <span>{{scope.row[item.prop]}}</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<Pagination @change="changeSize" :total="tableObj.total" ref="pagination" v-model="searchObj.page" v-if="Math.ceil(tableObj.total / searchObj.limit) > 1"></Pagination>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex'
	import Pagination from '@/components/pagination/pagination.vue'
	export default {
		name: 'RakeBack',
		data() {
			return {
				classNames: 'rakeBack',
                headerList: [
                    {
                        prop: 'create_date',
                        label: '时间',
                        width: 200
                    },
                    {
                        prop: 'total_price',
                        label: '总订单流水(元)',
                        width: 180
                    },
                    {
                        prop: 'commission',
                        label: '返佣比例(%)',
                        width: 150
                    },
                    {
                        prop: 'price',
                        label: '返佣金额(元)',
                        width: 150

                    },
                    {
                        prop: 'settle_date',
                        label: '结算时间',
                        width: 200
                    },
                    {
                        prop: 'status_name',
                        label: '状态'
                    }
                ],
                tableObj: {
                    list: [],
                    total: 0
                },
                noDataName: 'empty',
                searchObj: {
                    page: 1,
                    limit: 10
                }
			}
		},
		created() {
            this.getOrderReward()

		},
		components: {
			Pagination
		},
		computed: {
		},
		methods: {
            ...mapActions('rakeBack', ['orderReward']),
            async getOrderReward() {
                let res = await this.orderReward(this.searchObj)
                this.tableObj =  {
                    list: res.list,
                    total: res.page_info.total_count
                }
            },
            changeSize(size) {
                this.searchObj.page = size
                this.getOrderReward()
            }
		}
	}
</script>
<style lang="less">
	@classNames: rakeBack;
	.@{classNames} {
		.el-table::before {
			background-color: transparent;
		}
		.el-table__header {
			width: 100%!important;
		}
		.el-table__body {
			width: 100%!important;
		}
	}
	.@{classNames}_common_dialog {
		padding: 30px;
		width: 360px;
		box-sizing: border-box;
		.el-message-box__header {
			padding: 0;
		}
		.el-message-box__headerbtn {
			top: 0;
			right: 0;
		}
		.el-message-box__content {
			padding: 0;
			.el-message-box__message {
				padding-top: 12px;
				padding-bottom: 16px;
			}
		}
		.el-message-box__btns {
			.el-button {
				width: 77px;
				height: 28px;
				padding: 0;
				text-align: center;
				line-height: 28px;
			}
		}
	}
</style>
<style lang='less' scoped>
	@classNames: rakeBack;

	.@{classNames} {
		display: flex;
		flex-direction: column;
		height: 100%;

		.@{classNames}_search {
			display: flex;
			justify-content: space-between;
			margin-bottom: 40px;
			flex-shrink: 0;

			.@{classNames}_search_con {
				display: flex;

				.@{classNames}_search_con_item {
					display: flex;
					align-items: center;
					margin-right: 16px;

					.@{classNames}_search_con_item_title {
						white-space: nowrap;
						font-size: 14px;
						color: #606266;
						margin-right: 12px;
					}
				}
			}
		}

		.@{classNames}_con {	
			display: flex;
			flex-direction: column;
			flex: 1;
		}
	}
</style>
